import { create } from 'zustand';

export type TLeaderboardUser = {
  rank: number;
  userName: string;
  points: number;
  avatar_url?: string;
};

export type TLeaderboardPeriod = {
  topPlayers: TLeaderboardUser[];
  currentUser: TLeaderboardUser;
  totalUsers?: number;
};

export interface ILeaderboardStore {
  weekly: TLeaderboardPeriod | null;
  setWeekly: (period: TLeaderboardPeriod) => void;
  total: TLeaderboardPeriod | null;
  setTotal: (period: TLeaderboardPeriod) => void;
}

export const useLeaderboardStore = create<ILeaderboardStore>((set) => ({
  weekly: null,
  setWeekly: (period: TLeaderboardPeriod) => set({ weekly: period }),
  total: null,
  setTotal: (period: TLeaderboardPeriod) => set({ total: period }),
}));
